// extracted by mini-css-extract-plugin
export var infoItem = "_rn-2";
export var title = "_rn-0";
export var value = "_rn-1";